import Vue from "vue";

export default Vue.extend({
  methods: {
    beautifyName(firstname: string, lastname: string) {
      if (lastname == "" || lastname == null) {
        return firstname;
      }
      return lastname + ", " + firstname;
    },

    getGenderName(genderCode: number) {
      if (genderCode === 1) {
        if (
          Object.prototype.hasOwnProperty.call(
            window.templateLabels,
            "common.gender_male"
          )
        ) {
          return window.templateLabels["common.gender_male"];
        }
        return "Male";
      } else if (genderCode === 2) {
        if (
          Object.prototype.hasOwnProperty.call(
            window.templateLabels,
            "common.gender_female"
          )
        ) {
          return window.templateLabels["common.gender_female"];
        }
        return "Female";
      }
    },

    dateObjectToString(date: Date) {
      return (
        (date.getDate() > 9 ? "" : "0") +
        date.getDate() +
        "." +
        (date.getMonth() + 1 > 9 ? "" : "0") +
        (date.getMonth() + 1) +
        "." +
        date.getFullYear()
      );
    },

    convertDate(prop: any, obj?: any) {
      if (
        prop != null &&
        Object.prototype.toString.call(prop) === "[object Date]"
      ) {
        // Convert date object to date string
        return (
          prop.getFullYear() +
          "-" +
          (prop.getMonth() + 1 > 9 ? "" : "0") +
          (prop.getMonth() + 1) +
          "-" +
          (prop.getDate() > 9 ? "" : "0") +
          prop.getDate()
        );
      } else if (prop != null && obj != null) {
        // Convert date string to date object
        const parts = prop.split("-");
        return new Date(parts[0], parts[1] - 1, parts[2]);
      } else if (prop != null && obj == null) {
        // Convert date string format
        const parts = prop.split(".");
        return parts[2] + "-" + parts[1] + "-" + parts[0];
      }
    },

    convertDateTime(prop: any, obj?: any) {
      if (
        prop != null &&
        Object.prototype.toString.call(prop) === "[object Date]"
      ) {
        // Convert datetime object to datetime string
        return (
          prop.getFullYear() +
          "-" +
          (prop.getMonth() + 1 > 9 ? "" : "0") +
          (prop.getMonth() + 1) +
          "-" +
          (prop.getDate() > 9 ? "" : "0") +
          prop.getDate() +
          " " +
          (prop.getHours() > 9 ? "" : "0") +
          prop.getHours() +
          ":" +
          (prop.getMinutes() > 9 ? "" : "0") +
          prop.getMinutes() +
          ":" +
          (prop.getSeconds() > 9 ? "" : "0") +
          prop.getSeconds()
        );
      } else if (prop != null && obj != null) {
        // Convert datetime string to datetime object
        const parts = prop.split(" ");
        const dateParts = parts[0].split("-");
        const timeParts = parts[1].split(":");
        return new Date(
          dateParts[0],
          dateParts[1] - 1,
          dateParts[2],
          timeParts[0],
          timeParts[1],
          timeParts[2]
        );
      } else if (prop != null && obj == null) {
        // Convert datetime string format
        const parts = prop.split(" ");
        const dateParts = parts[0].split(".");
        return (
          dateParts[2] +
          "-" +
          dateParts[1] +
          "-" +
          dateParts[0] +
          " " +
          parts[1]
        );
      }
    }
  }
});
